var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({attrs:{"icon":"","elevation":"0"}},'v-btn',_vm.attrs,false),_vm.$listeners),[_c('v-icon',_vm._b({domProps:{"textContent":_vm._s(_vm.icon)}},'v-icon',_vm.attrsIcon,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }